var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select-field',{attrs:{"label":_vm.$t('common.separator'),"items":_vm.separators,"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }